import { render, staticRenderFns } from "./socketConfig.vue?vue&type=template&id=3cd6b0b9&scoped=true&"
import script from "./socketConfig.vue?vue&type=script&lang=js&"
export * from "./socketConfig.vue?vue&type=script&lang=js&"
import style0 from "./socketConfig.vue?vue&type=style&index=0&id=3cd6b0b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd6b0b9",
  null
  
)

export default component.exports